module.exports = __webpack_public_path__ + "img/print_produced.54fb2816.png";